// Type imports:
import { AlertTickData, IAlertConfigParameter, IAlertConfigParameterHistoryEntry, IAlertReviewAttachment } from '../types/api/AlertTypes';

export const findMostRecentHistoryEntry = (alertParameter: IAlertConfigParameter) => {
    const { alertConfigParameterHistory } = alertParameter;
    const mostRecentActiveParameterHistoryEntry = alertConfigParameterHistory.reduce((mostRecentSoFar: IAlertConfigParameterHistoryEntry | undefined, currentHistoryEntry: IAlertConfigParameterHistoryEntry) => {
        if (mostRecentSoFar === undefined) return currentHistoryEntry;
        if (new Date(mostRecentSoFar.created_timestamp) > new Date(currentHistoryEntry.created_timestamp)) return mostRecentSoFar;
        return currentHistoryEntry;
    }, undefined);
    return mostRecentActiveParameterHistoryEntry;
}

export const isParameterBoolean = (parameterId: string) => ['active'].includes(parameterId);
export const isParameterPercentNumber = (parameterId: string) => ['significant_percentage_change'].includes(parameterId);
export const isParameterString = (parameterId: string) => ['exclude_trader'].includes(parameterId);

export const getCauseTypeOfAlert = (alert: AlertTickData) => {
    const alertId = alert.id
    if (alertId === null) return null;
    if ([2,35].includes(alertId)) return 'Order';
    if ([1,5,6,30,31,33,34].includes(alertId)) return 'Trade';
    if ([3,4,7,8,25,26,29,32].includes(alertId)) return 'PrivateOrder';
    if ([10,11,12,13,14,15,16,19,21,22,23,27].includes(alertId)) return 'PrivateTrade';
    if ([9,17,18].includes(alertId)) return 'PrivateTradeReport';
    if (alertId === 20) {
        const privateTradeId = alert.private_trade_id;
        const privateTradeReportId = alert.private_trade_report_id;
        if (privateTradeId === null && privateTradeReportId === null) return null;
        if (privateTradeId !== null && privateTradeReportId !== null) return null;
        if (privateTradeReportId === null) return 'PrivateTrade';
        return 'PrivateTradeReport';
    }
    return null;
}